import { ArrowRightAlt } from "@mui/icons-material";
import { Box, Button, Card, Grid, Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import {
  MAIN_THEME_COLOR,
  SECONDARY_THEME_COLOR,
} from "../../../providers/theme/colors/colors";

const dexcoCards = [
  {
    title: "ICYM DEXCO",
    description:
      "ICYM Diocesan Executive Committe Members. Moto: To Lead, To Serve, To Shine",
  },
  {
    title: "YCS DEXCO",
    description: `YCS Diocesan Executive Committe Members. 
    Moto: See, Judge and Act`,
  },
  {
    title: "YSM DEXCO",
    description: "YSM Udupi District Executive Committe Members.",
  },
];

export default function DexcoInformation() {
  const navigate = useNavigate();

  return (
    <Box mb={{ xs: 4, md: 5 }} id="dexcoInfo">
      <Typography
        variant="h4"
        fontWeight={700}
        sx={{ fontSize: { xs: "2rem", md: "2.5rem" } }}
      >
        DEXCO
      </Typography>
      <Typography
        variant="h6"
        color="text.secondary"
        sx={{ fontSize: { xs: "1rem", md: "1.25rem" } }}
      >
        ICYM, YCS, and YSM leadership
      </Typography>

      <Box
        mt={2}
        p={{ xs: 2.5, md: 3 }}
        sx={{
          borderRadius: 4,
          background:
            "linear-gradient(135deg, rgba(64,162,227,0.10) 0%, rgba(255,255,255,1) 50%, rgba(255,214,10,0.12) 100%)",
          border: `1px solid ${SECONDARY_THEME_COLOR}`,
        }}
      >
        <Typography sx={{ maxWidth: 860, lineHeight: 1.8 }}>
          Click below to view the DEXCO's of ICYM, YCS and YSM. The youth
          leaders responsible for youth ministry in the Diocese.
        </Typography>
        <Button
          variant="contained"
          endIcon={<ArrowRightAlt />}
          sx={{ mt: 2, width: { xs: "100%", sm: "auto" } }}
          onClick={() => {
            navigate("/dexco");
            window.scrollTo(0, 0);
          }}
        >
          View DEXCO Page
        </Button>
      </Box>

      <Grid container spacing={3} mt={1}>
        {dexcoCards.map((item) => (
          <Grid item xs={12} sm={6} md={4} key={item.title}>
            <Card
              sx={{
                height: "100%",
                p: { xs: 2.25, md: 3 },
                borderRadius: 3,
                border: `1px solid ${SECONDARY_THEME_COLOR}`,
                boxShadow: "0 12px 28px rgba(15, 23, 42, 0.08)",
              }}
            >
              <Typography
                variant="h6"
                fontWeight={700}
                color={MAIN_THEME_COLOR}
              >
                {item.title}
              </Typography>
              <Typography
                variant="body2"
                color="text.secondary"
                mt={1.5}
                sx={{ lineHeight: 1.7 }}
              >
                {item.description}
              </Typography>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
